import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import ImageKey from 'shared/images/key.webp'
import { EmptyResults } from 'shared/ui/empty-result'

import s from './styles.module.scss'

interface EmptyProps {
  title?: string
  subtitle?: string
}

export const Empty = ({ title, subtitle }: EmptyProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('container', s.empty)}>
      <EmptyResults
        image={
          <div className={s.imageWrapper}>
            <img
              src={ImageKey}
              alt="404"
              className={s.image}
            />
          </div>
        }
        title={title || t('kyrgyzstan_block.empty.title')}
        subTitle={subtitle || t('kyrgyzstan_block.empty.subtitle')}
      />
    </div>
  )
}
